webpackJsonp([2],{

/***/ "+qiR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _row = __webpack_require__("0b0c");

var _row2 = _interopRequireDefault(_row);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__("1szz");

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactIntlUniversal = __webpack_require__("cl+9");

var _reactIntlUniversal2 = _interopRequireDefault(_reactIntlUniversal);

var _ForbiddenPage = __webpack_require__("Vqcb");

var _ForbiddenPage2 = _interopRequireDefault(_ForbiddenPage);

var _Button = __webpack_require__("KluA");

var _Button2 = _interopRequireDefault(_Button);

var _ipad = __webpack_require__("AVik");

var _ipad2 = _interopRequireDefault(_ipad);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ForbiddenPage = function (_Component) {
  (0, _inherits3.default)(ForbiddenPage, _Component);

  function ForbiddenPage() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ForbiddenPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ForbiddenPage.__proto__ || (0, _getPrototypeOf2.default)(ForbiddenPage)).call.apply(_ref, [this].concat(args))), _this), _this.download = function () {
      window.open('http://www.jianshu.com/apps/download');
    }, _this.toHome = function () {
      window.location.href = window.location.origin;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ForbiddenPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _row2.default,
        { className: _ForbiddenPage2.default['wrap'] },
        _react2.default.createElement(
          'div',
          { className: _ForbiddenPage2.default['content'] },
          _react2.default.createElement('img', { className: _ForbiddenPage2.default['img'], src: _ipad2.default, alt: '' }),
          _react2.default.createElement(
            'span',
            { className: _ForbiddenPage2.default['desc'] },
            _reactIntlUniversal2.default.get('global.forbidden-desc')
          ),
          _react2.default.createElement(
            _Button2.default,
            {
              className: _ForbiddenPage2.default['btn'],
              type: 'primary',
              strong: true,
              onClick: this.download
            },
            _reactIntlUniversal2.default.get('global.download')
          ),
          _react2.default.createElement(
            _Button2.default,
            {
              className: _ForbiddenPage2.default['btn'],
              type: 'primary',
              onClick: this.toHome
            },
            _reactIntlUniversal2.default.get('global.to-home')
          )
        )
      );
    }
  }]);
  return ForbiddenPage;
}(_react.Component);

exports.default = ForbiddenPage;

/***/ }),

/***/ "1qel":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "._3cfL1{text-align:center;margin:40px}._2DQCa{text-align:left;margin-bottom:24px}._2DQCa ._2cyDl{width:300px;cursor:pointer}._1o-HY ._1az2Q{width:220px}._1o-HY ._2dGVm{font-size:18px;margin:40px 0 20px}body.reader-night-mode ._1o-HY ._2dGVm{color:#b3b3b3}._1o-HY ._3BFwp{font-size:14px;margin-bottom:30px;color:#333}body.reader-night-mode ._1o-HY ._3BFwp{color:#b3b3b3}._3h9Y3{height:48px;border-radius:24px;font-size:15px;padding:6px 20px}", ""]);

// exports
exports.locals = {
	"wrapper": "_3cfL1",
	"header": "_2DQCa",
	"logo": "_2cyDl",
	"content": "_1o-HY",
	"img-404": "_1az2Q",
	"title": "_2dGVm",
	"desc": "_3BFwp",
	"btn": "_3h9Y3"
};

/***/ }),

/***/ "AVik":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOoAAACiCAMAAAB4QaF9AAAASFBMVEUAAACzs7O1tbW0tLSvr6+9vb20tLS0tLS3t7e0tLS0tLS0tLS0tLS0tLSzs7Ovr6+0tLS1tbW0tLS0tLS0tLS0tLSzs7O1tbUx8YHuAAAAGHRSTlMAgF10Igt5Bw9WPzVqYxQEGlAsb0UnSi98qNrrAAAEMElEQVR42u3d25KjIBCA4W4PgKKCx7z/m242M2YTI6LxCNv/1V5speorZ2KLysCaoi5jeGCsTm4KTqgI8ITCGxxexfCcOgXH1uJpdXBoguF53eDISjyxkMNxxbgolw/rDU8tgOPq8NRCOK4Ez03BYQV4bhxMEZWoM6kRnBMjah9RiUpUoloiKlGJStSxiEpUohLVElGJSlSiblFcNY0U/lNjGeCjUnlN5bcAn+XcW+rT+bT6SeVVgh9J/6h3J8ORGPeLqnrnSDefqPruNFf6Q+UJThZ4Q1U53vsvjqpES6k31Bwttd5QGVry52SDlgJ/RogaX/N6WuosVOEPVeNk2fXG/b2etmp8osY1vsQGVO0TFYqsd9WNHhzj8IKrEGviaf3jBFAM3yo9o94TBYe/Rfhe5R/VdOrh/lJrfCu44uLoNml8T/pLTQdUcTq1yhkuieUSZpWPj0pcF+dQeYLLC2KwF4+NSrrJEDFs4rnU05+bD75YkdBQpDX+FupXKitbBeOd/4aWXP7sdprhS6yAZ4XBeYWDipiDLc6+ucop0jzMUg47VON3sfU/L9Wnsz/wdQHbF+KXrX/PLTA4+/fU3KFaP5mZnP2rlq5QI7QWjzj7mAJwhdqgpX76rzIcS+9BjWFxM6gZ2qr76XG0yBmqQGvp5LqbAHCE2qKtTE3d5AkBXKHe0FISTy4clwCuUFucipXacuuuAnCFKiacyctsH7MvXj4syrAuxVWokJmclYLX5OIRW5Q/n6SvQpXjTm684KhL/FdqhnbPT+MXoUKOg4Ibh7FkzjBr9Ns3WQHjxQ3DZ/Iq1IJZnX1KDa4na9NqOsOXyqtQQddPp4zBmmKWYV/10L7uMlRQMkdkvdNWZHliog1xUHod6j3FYW7N4LLGfqKuLkVdUPZ+0a6bvA7k5MlLO0oVLwapmxof5fHE1eZlTjYLk+N3oAPzel94lRFiq20w5PBbK3/+w1Eqt67CVvi3pKjwt9JRamtf2RFp2RQA6eu5hlcyco1aoqHQ+D+r3zExE25RQzSUGGfrqJ+e6tglqkJDrIBB7PN7unGJKgzSQM/ZMi53iaoYfpalxbxH+xKXqJCYnfb1udYpqp7hNCyRM+nWNzCkBqf18HexY+dVgIqZneZ1nFI4Ny3dU5FsxbJf6qRwcDD85goo0E7OwLNTdX8yjRwd9+evzIjsB3qZGxnL0l0YLXiRMk31he7ZLL6smaJe+/bUBTdLICpRiUpUohIVBhGVqEQlKlGJSlSiEpWoj4hKVKISlahEJSpRiUrUR0QlKlGJSlSiEpWoRCXqI6ISlahEJeoU1YE/4S6IStS9qQk+25X6ZbBhHa7LIeoN1+UQNcZ1OUSFEndLbLq96voEw70S226au74W90psvBXy+iqG+yTWb3C9dUWAuyTWb1u+fVGXsR2oO21G/wdEPzkKrOJYygAAAABJRU5ErkJggg=="

/***/ }),

/***/ "OLkl":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "._3WfQG{text-align:center;height:100%;background-color:#fff}body.reader-night-mode ._3WfQG{background-color:#3d3d3d}._2MMKQ{position:absolute;width:210px;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}._3nVTv{width:100%}._1zoXW{display:inline-block;margin:40px 0;font-size:16px;color:#595959}body.reader-night-mode ._1zoXW{color:#b3b3b3}.jBc_o{width:100%;height:40px;margin-bottom:20px;font-size:16px;border-radius:20px}.jBc_o:last-child{margin-bottom:0}.jBc_o+.jBc_o{margin-left:0}", ""]);

// exports
exports.locals = {
	"wrap": "_3WfQG",
	"content": "_2MMKQ",
	"img": "_3nVTv",
	"desc": "_1zoXW",
	"btn": "jBc_o"
};

/***/ }),

/***/ "Vqcb":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("OLkl");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./ForbiddenPage.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./ForbiddenPage.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "cpRm":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "d6jq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _row = __webpack_require__("0b0c");

var _row2 = _interopRequireDefault(_row);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__("1szz");

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactIntlUniversal = __webpack_require__("cl+9");

var _reactIntlUniversal2 = _interopRequireDefault(_reactIntlUniversal);

var _NotFoundPage = __webpack_require__("qsQA");

var _NotFoundPage2 = _interopRequireDefault(_NotFoundPage);

var _error_page_logo = __webpack_require__("cpRm");

var _error_page_logo2 = _interopRequireDefault(_error_page_logo);

var _img_ = __webpack_require__("nb12");

var _img_2 = _interopRequireDefault(_img_);

var _Button = __webpack_require__("KluA");

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotFoundPage = function (_Component) {
  (0, _inherits3.default)(NotFoundPage, _Component);

  function NotFoundPage() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, NotFoundPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = NotFoundPage.__proto__ || (0, _getPrototypeOf2.default)(NotFoundPage)).call.apply(_ref, [this].concat(args))), _this), _this.toHome = function () {
      window.location.href = window.location.origin;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(NotFoundPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _row2.default,
        { className: _NotFoundPage2.default['wrapper'] },
        _react2.default.createElement(
          'header',
          { className: _NotFoundPage2.default['header'] },
          _react2.default.createElement('img', { onClick: this.toHome, className: _NotFoundPage2.default['logo'], src: _error_page_logo2.default, alt: '' })
        ),
        _react2.default.createElement(
          'div',
          { className: _NotFoundPage2.default['content'] },
          _react2.default.createElement('img', { className: _NotFoundPage2.default['img-404'], src: _img_2.default, alt: '' }),
          _react2.default.createElement(
            'h3',
            { className: _NotFoundPage2.default['title'] },
            _reactIntlUniversal2.default.get('not-found.title')
          ),
          _react2.default.createElement(
            'p',
            { className: _NotFoundPage2.default['desc'] },
            _reactIntlUniversal2.default.get('not-found.desc'),
            ' : ',
            _react2.default.createElement(
              'strong',
              null,
              window.location.href
            )
          ),
          _react2.default.createElement(
            _Button2.default,
            { onClick: this.toHome, className: _NotFoundPage2.default['btn'], type: 'primary', strong: true },
            _reactIntlUniversal2.default.get('not-found.to-home')
          )
        )
      );
    }
  }]);
  return NotFoundPage;
}(_react.Component);

exports.default = NotFoundPage;

/***/ }),

/***/ "nb12":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "qsQA":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("1qel");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./NotFoundPage.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./NotFoundPage.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ })

});


// WEBPACK FOOTER //
// static/js/forbidden.chunk.651fb08b93ae39f0d5a3.js